import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ClinicMedicationsPage } from './clinic-medications';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  declarations: [
    ClinicMedicationsPage,
  ],
  imports: [
    IonicPageModule.forChild(ClinicMedicationsPage),
    DirectivesModule
  ],
})
export class ClinicMedicationsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/clinic-medications/clinic-medications.module.ts